import { render, staticRenderFns } from "./PresenceManagement.vue?vue&type=template&id=c7904954&"
import script from "./PresenceManagement.vue?vue&type=script&lang=js&"
export * from "./PresenceManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports